/** Stroke icons on a 20 × 20 grid, 1.5 px round strokes; the stylesheet sizes and colours them. */
const I = (body: string): string => `<svg viewBox="0 0 20 20" aria-hidden="true">${body}</svg>`;

export const icons = {
  /** Brand mark: a frame of pins with one accent chord. */
  mark: '<svg viewBox="0 0 32 32" aria-hidden="true"><circle cx="16" cy="16" r="11" opacity="0.28"/><path d="M16 5L6.5 21.5M6.5 21.5L25.5 10.5M25.5 10.5L10.5 25.5"/><path d="M10.5 25.5L27 16" stroke="#c0442e"/><g fill="currentColor" stroke="none"><circle cx="16" cy="5" r="1.3"/><circle cx="6.5" cy="21.5" r="1.3"/><circle cx="25.5" cy="10.5" r="1.3"/><circle cx="10.5" cy="25.5" r="1.3"/><circle cx="27" cy="16" r="1.3"/></g></svg>',

  // side tabs
  image: I('<rect x="3" y="4" width="14" height="12" rx="1"/><path d="M3 14l4-4 3 3 2-2 5 5"/><circle cx="13" cy="8" r="1.4"/>'),
  sliders: I('<path d="M3 6h9M15 6h2M3 14h3M9 14h8"/><circle cx="13" cy="6" r="2"/><circle cx="7" cy="14" r="2"/>'),
  pins: I('<g fill="currentColor" stroke="none"><circle cx="17" cy="10" r="1.2"/><circle cx="14.95" cy="14.95" r="1.2"/><circle cx="10" cy="17" r="1.2"/><circle cx="5.05" cy="14.95" r="1.2"/><circle cx="3" cy="10" r="1.2"/><circle cx="5.05" cy="5.05" r="1.2"/><circle cx="10" cy="3" r="1.2"/><circle cx="14.95" cy="5.05" r="1.2"/></g><path d="M10 3L5.05 14.95L17 10L5.05 5.05"/>'),
  wand: I('<path d="M3 17L13 7M12 3l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7zM16 9l.4 1.2 1.2.4-1.2.4-.4 1.2-.4-1.2-1.2-.4 1.2-.4z"/>'),
  brush: I('<path d="M11.5 3.5l5 5-6.5 6.5-5-5z"/><path d="M6 12.5c-1.5 1-2 2-1.5 3.5 1.5.5 2.5 0 3.5-1.5"/><path d="M3.5 17.5c1-.2 1.8-.7 2.5-1.5"/>'),
  edit: I('<path d="M4 16l1-4 9-9 3 3-9 9zM12 5l3 3"/>'),
  exportBox: I('<path d="M10 12V3M7 6l3-3 3 3"/><path d="M4 11v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-4"/>'),

  // tool rail
  select: I('<path d="M4 3l12 7-5 1.5L8.5 17z"/>'),
  addString: I('<circle cx="5" cy="15" r="1.6"/><circle cx="15" cy="5" r="1.6"/><path d="M6.2 13.8L13.8 6.2"/><path d="M15.5 12v5M13 14.5h5"/>'),
  hand: I('<path d="M7 10V4.5a1.5 1.5 0 0 1 3 0V9M10 8.5V3.5a1.5 1.5 0 0 1 3 0V9M13 6.5a1.5 1.5 0 0 1 3 0V12a5 5 0 0 1-5 5h-1a5 5 0 0 1-4.3-2.4L3 10.5a1.4 1.4 0 0 1 2.4-1.4L7 11.5"/>'),
  fit: I('<path d="M3 7V4a1 1 0 0 1 1-1h3M13 3h3a1 1 0 0 1 1 1v3M17 13v3a1 1 0 0 1-1 1h-3M7 17H4a1 1 0 0 1-1-1v-3"/><rect x="7" y="7" width="6" height="6" rx="1"/>'),
  zoomIn: I('<circle cx="9" cy="9" r="5.5"/><path d="M13 13l4 4M9 6.5v5M6.5 9h5"/>'),
  zoomOut: I('<circle cx="9" cy="9" r="5.5"/><path d="M13 13l4 4M6.5 9h5"/>'),

  // top bar and transport
  undo: I('<path d="M8 5L4 9l4 4M4 9h7a5 5 0 0 1 0 10h-1"/>'),
  redo: I('<path d="M12 5l4 4-4 4M16 9H9a5 5 0 0 0 0 10h1"/>'),
  play: I('<path d="M6 4l10 6-10 6z"/>'),
  pause: I('<path d="M7 4v12M13 4v12"/>'),
  skipStart: I('<path d="M14 4l-7 6 7 6M5 4v12"/>'),
  stepBack: I('<path d="M12 5l-5 5 5 5"/>'),
  stepForward: I('<path d="M8 5l5 5-5 5"/>'),
  skipEnd: I('<path d="M6 4l7 6-7 6M15 4v12"/>'),
  step: I('<path d="M4 5l5 5-5 5M11 5l5 5-5 5"/>'),
  stop: I('<rect x="5" y="5" width="10" height="10" rx="1.5"/>'),
  trash: I('<path d="M4 6h12M8 6V4h4v2M6 6l1 10h6l1-10M9 9v4M11 9v4"/>'),
  folder: I('<path d="M3 5.5A1.5 1.5 0 0 1 4.5 4H8l2 2h5.5A1.5 1.5 0 0 1 17 7.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 3 14.5z"/>'),
  download: I('<path d="M10 3v10M6 9l4 4 4-4M4 16h12"/>'),
  gauge: I('<path d="M3.5 13.5a7 7 0 1 1 13 0"/><path d="M10 13l3.5-4.5"/><circle cx="10" cy="13" r="1.2"/>'),
  refresh: I('<path d="M15.5 6.5A6.5 6.5 0 1 0 17 11M15.5 3v3.5H12"/>'),

  // editing
  lock: I('<rect x="5" y="9" width="10" height="8" rx="1"/><path d="M7 9V7a3 3 0 0 1 6 0v2"/>'),
  unlock: I('<rect x="5" y="9" width="10" height="8" rx="1"/><path d="M7 9V7a3 3 0 0 1 5.7-1.3"/>'),
  up: I('<path d="M10 16V4M5 9l5-5 5 5"/>'),
  down: I('<path d="M10 4v12M5 11l5 5 5-5"/>'),
  plus: I('<path d="M10 4v12M4 10h12"/>'),
  close: I('<path d="M5 5l10 10M15 5L5 15"/>'),
  back: I('<path d="M12 4l-6 6 6 6"/>'),
  copy: I('<rect x="7" y="7" width="9" height="9" rx="1"/><path d="M4 13V4h9"/>'),
  check: I('<path d="M4 10.5l4 4 8-9"/>'),
  crosshair: I('<circle cx="10" cy="10" r="5"/><path d="M10 3v3M10 14v3M3 10h3M14 10h3"/>'),
} as const;

export type IconName = keyof typeof icons;

/** Turns icon markup into an element the DOM helpers can append. */
export function svgIcon(markup: string): Element {
  const t = document.createElement('template');
  t.innerHTML = markup.trim();
  const el = t.content.firstElementChild;
  if (!el) throw new Error('svgIcon: empty markup');
  return el;
}
